<template>
  <section id="oppreg-qa" >
    <v-container fluid>
      <v-layout class="mt-3">
        <v-flex md12>
          <v-stepper v-model="formStep">
            <v-stepper-header>
              <v-stepper-step
                :editable="formStep>1 || type==='view'"
                step="1">Step 1</v-stepper-step>
              <v-divider />
              <v-stepper-step
                :editable="formStep>2 && workloadForm.fields.Q7 !== 'Y' || type==='view'"
                step="2">Step 2</v-stepper-step>
              <v-divider />
              <v-stepper-step
                :editable="type==='view'"
                step="3">Step 3</v-stepper-step>
              <v-divider v-if="type==='view' && workloadForm.fields.Workload_Type_Date_Change && workloadForm.fields.Workload_Type_Date_Change !== 'None'" />
              <v-stepper-step
                editable
                v-if="type==='view' && workloadForm.fields.Workload_Type_Date_Change && workloadForm.fields.Workload_Type_Date_Change !== 'None'"
                step="4">Discount Update</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                step="1"
                class="qa-form"
                style="position:relative">
                <strong>NOTE: All fields with <span class="required">*</span> are required. And please answer the questions in order they are presented</strong>
                <v-layout
                  row
                  wrap
                  class="mb-3">
                  <v-flex
                    xs12
                    sm12
                    md8>
                    <label>Project / Workload Title</label>
                    <v-text-field
                      v-model="workloadForm.fields.Workload_Title"
                      placeholder="Project / Workload Title"
                      name="Workload_Title"
                      solo
                      readonly
                    />
                  </v-flex>
                  <v-flex
                    v-if="!manualRegistration"
                    xs12
                    sm12
                    md8>
                    <label>DXC campaign name</label>
                    <v-text-field
                      v-model="workloadForm.fields.Campaign_Name"
                      placeholder="DXC campaign name"
                      solo
                      readonly
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex
                    v-if="manualRegistration"
                    xs12
                    sm12
                    md8>
                    <v-checkbox
                      class="d-inline-flex"
                      v-model="workloadForm.fields.Is_Glacier"
                      color="orange"
                      true-value="Y"
                      false-value="N"
                      @change="toggleIsGlacier"/>
                    <label style="position:relative; bottom: 3px">Check the box if your OPX has been DXC Regionally vetted as the Glacier Campaign</label>
                  </v-flex>
                </v-layout>
                <v-layout v-if="workloadForm.fields.Campaign_Name.includes('Glacier')" class="sow-field">
                  <v-flex
                    md8
                    class="pt-2">
                    <label>Glacier SOW Qty <span class="required">*</span></label>
                    <p>If your Glacier OPX is only for Assess Phase, please select zero in the SOW drop down.</p>
                    <p>If the SOW quantity changes in the future, please notify <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a> and the DXC Oppreg admin team will update the record.</p>
                  </v-flex>
                  <v-flex md2 >
                    <v-select
                      v-validate="{ required: true }"
                      :items="['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10']"
                      v-model="workloadForm.fields.Scope_of_Work"
                      :error-messages="errors.collect('Scope_of_Work')"
                      :readonly="type==='view'"
                      placeholder="Select an option"
                      data-vv-validate-on="blur"
                      data-vv-name="Scope_of_Work"
                      solo
                      attach
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    sm12 
                    md8
                  >
                    <label>Select from the drop down list the DXC business segment that best describes the overall OPX <span class="required">*</span></label>
                    <v-select
                      v-model="workloadForm.fields.Solution_Business_Segment"
                      :items="solutionBusinessSegments"
                      label="Please select one"
                      v-validate="{ required: true }"
                      data-vv-validate-on="blur"
                      data-vv-name="Solution_Business_Segment"
                      :error-messages="errors.collect('Solution_Business_Segment')"
                      solo
                      attach
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md12>
                    <label class="font-weight-bold">Project Description</label>
                    <hr class="my-2">
                    <label>1. What are the client's pain points and business objectives? What is the plan for AWS in support of the client’s desired outcomes? <span class="required">*</span></label>
                    <v-textarea
                      v-validate="{ required: true }"
                      v-model.lazy="workloadForm.fields.Q1"
                      :error-messages="errors.collect('projectDesc1')"
                      data-vv-name="projectDesc1"
                      data-vv-validate-on="blur"
                      solo
                      rows="3"
                      :readonly="type==='view'"
                    />
                  </v-flex>
                  <v-flex md12>
                    <label>2. What is the role of DXC in this project? Which Software applications  and/or tools will support the solution? <span class="required">*</span></label>
                    <v-textarea
                      v-validate="{ required: true }"
                      v-model.lazy="workloadForm.fields.Q2"
                      :error-messages="errors.collect('projectDesc2')"
                      data-vv-name="projectDesc2"
                      data-vv-validate-on="blur"
                      solo
                      rows="3"
                      :readonly="type==='view'"
                    />
                  </v-flex>
                  <v-flex md12>
                    <label>3. What specific client department or subsidiary is DXC working with? <span class="required">*</span></label>
                    <v-textarea
                      v-validate="{ required: true }"
                      v-model.lazy="workloadForm.fields.Q3"
                      :error-messages="errors.collect('projectDesc3')"
                      data-vv-name="projectDesc3"
                      data-vv-validate-on="blur"
                      solo
                      rows="3"
                      :readonly="type==='view'"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    md6
                    class="pt-2">
                    <label>4. What is the monthly estimated AWS spend for this opportunity (in USD)<span class="required">*</span></label>
                    <p>If you are unsure, Feel free to use these estimates.
                      <ul>
                        <li>Migrations or SaaS $15,000 per month (or greater)</li>
                        <li>SAP Migration $20,000 per month (or greater)</li>
                        <li>Managed Services $20,000 per month (or greater)</li>
                      </ul>
                    </p>
                  </v-flex>
                  <v-flex md6 >
                    <v-text-field
                      v-validate="'required|decimal:2'"
                      v-model="workloadForm.fields.Q4"
                      :error-messages="errors.collect('Projected_Monthly_Spend')"
                      type="number"
                      prepend-icon="attach_money"
                      class="padding-left-15"
                      data-vv-name="Projected_Monthly_Spend"
                      data-vv-validate-on="blur"
                      solo
                      :readonly="type==='view'"
                    />
                  </v-flex>
                </v-layout>
                <div class="mt-2 px-2 py-1 black">
                  <label class="font-weight-bold white--text">Additional Questions</label>
                </div>
                <v-layout
                  row
                  wrap
                  align-center>
                  <v-flex
                    md10
                    pt-2>
                    <label>5. Is the client categorized in the Public Sector industry segment?
                      <span class="required">*</span>
                    </label>
                  </v-flex>
                  <v-flex
                    md2>
                    <v-layout 
                      column
                      align-end>
                      <v-flex>
                        <v-btn-toggle v-model="workloadForm.fields.Q5" >
                          <v-btn
                            id="q1"
                            :class="{ 'v-btn--active': workloadForm.fields.Q5 === 'Y',
                                'disable-events': type==='view' }"
                            value="Y"
                            class="black--text btn--qa">Yes</v-btn>
                          <v-btn
                            :class="{ 'v-btn--active': workloadForm.fields.Q5 === 'N',
                                'disable-events': type==='view' }"
                            value="N"
                            class="black--text btn--qa">No</v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  align-center>
                  <v-flex
                    md10
                    pt-2>
                    <label>6. If the client is in the Public Sector industry, will DXC be providing Advisory Services that encompass a Cloud Service provider selection or procurement? 
                      <span class="required">*</span>
                    </label>
                  </v-flex>
                  <v-flex
                    md2>
                    <v-layout 
                      column
                      align-end>
                      <v-flex>
                        <v-btn-toggle v-model="workloadForm.fields.Q6" @change="displayPublicSectorMessage">
                          <v-btn
                            
                            id="q1"
                            :class="{ 'v-btn--active': workloadForm.fields.Q6 === 'Y' }"
                            value="Y"
                            class="black--text btn--qa">Yes</v-btn>
                          <v-btn
                            
                            :class="{ 'v-btn--active': workloadForm.fields.Q6 === 'N',
                                'disable-events': type==='view' }"
                            value="N"
                            class="black--text btn--qa">No</v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  align-center>
                  <v-flex
                    md10
                    pt-2>
                    <label class="font-weight-bold">7.  In this opportunity, will the client's current non-DXC AWS account be transferring to a DXC owned Master payer?.
                      <span class="required">*</span>
                    </label>
                    <p class="pr-5">If YES, then send an email to the DXC Account Onboarding team at <a href="mailto:aws-account-onboarding@cloud.dxc.com">aws-account-onboarding@cloud.dxc.com</a> regarding “Consent to Assignment”.  The team will assist with account transfer pricing and requirement guidance for the AWS Consent To Assignment (CTA) process.<br /> You must also tag your DXC SF opportunity in the product detail Technology Provider field with “Amazon Web Services”. Once your SF tag is verified by the DXC Oppreg team, your registration will be submitted to AWS.</p>
                  </v-flex>
                  <v-flex
                    md2>
                    <v-layout
                      column
                      align-end>
                      <v-flex>
                        <v-btn-toggle v-model="workloadForm.fields.Q7" @change="determineWorkloadType">
                          <v-btn
                            id="q1"
                            :class="{ 'v-btn--active': workloadForm.fields.Q7 === 'Y',
                                'disable-events': type==='view' }"
                            value="Y"
                            class="black--text btn--qa">Yes</v-btn>
                          <v-btn
                            :class="{ 'v-btn--active': workloadForm.fields.Q7 === 'N',
                                'disable-events': type==='view' }"
                            value="N"
                            class="black--text btn--qa">No</v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- <v-layout
                  row
                  wrap>
                  <v-flex md10>
                    <p>If the client is requesting that existing workload(s) transfer to a DXC Account Master Payer, the applicable AWS process is called CTA: Customer Transfer Account.</p>
                    <ul>
                      <li><p>Please request via email the Account Onboarding team to process this transfer workload aws-account-onboarding@cloud.dxc.com.</p></li>
                      <li><p>Pricing on a transfer workload to DXC will be determined through your regional AWS Partner Development Manager (PDM).  Proceed to Step 3 Contact Information.</p></li>
                    </ul>
                  </v-flex>
                </v-layout> -->
                <v-layout v-if="type === 'new'">
                  <v-flex class="text-md-center">
                    <v-btn color="success" @click="goBackToStep()">GO BACK</v-btn>

                    <span v-if="workloadForm.fields.Q7 == 'Y'">
                      <v-btn
                        :disabled="stepOneValidation"
                        color="success"
                        @click="onWorkloadStepContinue(3)">
                        CONTINUE
                      </v-btn>
                    </span>
                    <span v-else>
                      <v-btn
                        :disabled="stepOneValidation"
                        color="success"
                        @click="onWorkloadStepContinue(2)">
                        CONTINUE
                      </v-btn>
                    </span>
                    <!-- <v-btn
                      v-if="workloadForm.fields.Q7 == 'Y'"
                      :disabled="stepOneValidation"
                      color="success"
                      @click="onWorkloadStepContinue(3)">
                      CONTINUE
                    </v-btn>
                    <v-btn
                      v-if="workloadForm.fields.Q7 == 'N'"
                      :disabled="stepOneValidation"
                      color="success"
                      @click="onWorkloadStepContinue(2)">
                      CONTINUE
                    </v-btn> -->
                  </v-flex>
                </v-layout>
              </v-stepper-content>

              <v-stepper-content
                step="2"
                class="qa-form"
                style="position:relative">
                <v-btn v-if="type === 'view' && (workloadForm.fields.Q8 || workloadForm.fields.Q9 || workloadForm.fields.Q10)" class="btn--qa red--text" @click="viewOldPricingQA = !viewOldPricingQA">
                  <span v-if="!viewOldPricingQA">
                    If applicable, Click Here to View Old Pricing Tier Questions and Answers
                  </span>
                  <span v-else>
                    Go Back
                  </span>
                </v-btn>

                <div v-if="viewOldPricingQA" class="old-pricing-qa border-2">
                  <div class="pricing-tier-overview-container">
                    <div class="my-2 px-2 py-1 black">
                      <label class="font-weight-bold white--text">Pricing Tiers Overview</label>
                    </div>
                    <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                    <ul>
                      <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                      <li>Private Pricing Agreement (PPA) – 23% discount for qualified workloads.</li>
                      <li>View the OppReg guide download for pricing tier details. </li>
                    </ul>
                  </div>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex md12 style="position: relative;">
                      <div class="my-2 px-2 py-1 black">
                        <label class="font-weight-bold white--text">Pricing Tier Qualification</label>
                      </div>
                      <div class="my-2">
                        <label>Answer the following questions to determine the applicable Pricing Tier – final tier approval will be provided by Galaxy email to you upon AWS approval. </label>
                      </div>
                      <v-layout align-center>
                        <v-flex md9>
                          <label class="mr-3 font-weight-bold">8. Will the client require access to DXC’s AWS login credentials, the AWS Management Console or AWS resources, e.g. S3 storage or EC2 instances? If YES, then workload qualifies for SPP and there is no need for questions 9 and 10.  <span class="required">*</span></label>
                        </v-flex>
                        <v-flex md3 class="text-md-center">
                          <v-btn-toggle v-model="workloadForm.fields.Q8" @change="determineWorkloadType">
                            <v-btn
                              :class="{ 
                                'v-btn--active': workloadForm.fields.Q8 === 'Y',
                                'disable-events': type==='view' }"
                              value="Y"
                              class="black--text btn--qa">Yes</v-btn>
                            <v-btn
                              :class="{ 
                                'v-btn--active': workloadForm.fields.Q8 === 'N',
                                'disable-events': type==='view' }"
                              value="N"
                              class="black--text btn--qa">No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                      <v-layout align-center v-if="workloadForm.fields.Q8 == 'Y'">
                        <v-flex md9>
                          <div class="px-2 py-1 black text-md-right">
                            <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                          </div>
                        </v-flex>
                        <v-flex md3>
                          <div class="d-flex align-center">
                            <div class="text-md-center black px-2 py-1">
                              <span class="font-weight-bold white--text">SPP Pricing Tier</span>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout align-center style="position:relative">
                        <!-- <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8" class="disabled-section"></div> -->
                        <v-flex md9>
                          <label class="mr-3 font-weight-bold">9. Will the AWS resources be used for a SaaS or PaaS solution delivered by DXC? If YES, then workload qualifies for PPA and there is no need for question 10.<span v-if="workloadForm.fields.Q7 == 'N'" class="required">*</span></label>
                        </v-flex>
                        <v-flex md3 class="text-md-center">
                          <v-btn-toggle v-model="workloadForm.fields.Q9" @change="determineWorkloadType">
                            <v-btn
                              :class="{
                                'v-btn--active': workloadForm.fields.Q9 === 'Y',
                                'disable-events': type==='view'
                              }"
                              value="Y"
                              class="black--text btn--qa">Yes</v-btn>
                            <v-btn
                              :class="{ 
                                'v-btn--active': workloadForm.fields.Q9 === 'N',
                                'disable-events': type==='view'
                              }"
                              value="N"
                              class="black--text btn--qa">No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                      <v-layout align-center style="position:relative" v-if="workloadForm.fields.Q9 == 'Y'">
                        <!-- <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8" class="disabled-section"></div> -->
                        <v-flex md9>
                          <div class="px-2 py-1 black text-md-right">
                            <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                          </div>
                        </v-flex>
                        <v-flex md3>
                          <div class="d-flex align-center">
                            <div class="text-md-center black px-2 py-1">
                              <span class="font-weight-bold white--text">PPA Pricing Tier</span>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout align-center style="position:relative">
                        <!-- <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8  || workloadForm.fields.Q9 == 'Y' || !workloadForm.fields.Q9" class="disabled-section"></div> -->
                        <v-flex md9>
                          <label class="mr-3 font-weight-bold">10. For existing non-AWS workloads, has DXC been providing managed services for the workload(s) since September 1, 2018? If YES, then workload qualifies for PPA.<span v-if="workloadForm.fields.Q7 == 'N' && workloadForm.fields.Q8 == 'N'" class="required">*</span></label>
                        </v-flex>
                        <v-flex md3 class="text-md-center">
                          <v-btn-toggle v-model="workloadForm.fields.Q10" @change="determineWorkloadType">
                            <v-btn
                              
                              :class="{ 
                                'v-btn--active': workloadForm.fields.Q10 === 'Y',
                                'disable-events': type==='view' }"
                              value="Y"
                              class="black--text btn--qa">Yes</v-btn>
                            <v-btn
                              
                              :class="{ 
                                'v-btn--active': workloadForm.fields.Q10 === 'N',
                                'disable-events': type==='view'
                              }"
                              value="N"
                              class="black--text btn--qa">No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                      <v-layout align-center style="position:relative" v-if="workloadForm.fields.Q10">
                        <!-- <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8  || workloadForm.fields.Q9 == 'Y' || !workloadForm.fields.Q9" class="disabled-section"></div> -->
                        <v-flex md9>
                          <div class="px-2 py-1 black text-md-right">
                            <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                          </div>
                        </v-flex>
                        <v-flex md3>
                          <div class="d-flex align-center black px-2 py-1">
                            <div class="font-weight-bold text-md-center white--text" v-if="workloadForm.fields.Q10 == 'Y'">
                              PPA Pricing Tier
                            </div>
                            <div class="font-weight-bold text-md-center white--text" v-if="workloadForm.fields.Q10 == 'N'">
                              SPP Pricing Tier
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>

                <formUserOppregWorkloadStep2New v-else :type="type" @continue="onWorkloadStepContinue(3)"/>
                
                <v-layout v-if="type === 'new'">
                  <v-flex class="text-md-center">
                    <v-btn color="success" @click="goBackToStep(1)">GO BACK</v-btn>
                    <v-btn
                        :disabled="stepTwoValidation"
                        color="success"
                        @click="onWorkloadStepContinue(3)">
                        CONTINUE
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content
                step="3"
                class="qa-form"
                style="position:relative">
                <v-layout
                  row
                  wrap>
                  <v-flex
                    xs12
                    md12 >
                    <span style="font-weight: bold">Contact Information <span class="required">*</span></span>
                    <v-checkbox
                      :disabled="type==='view'"
                      id=""
                      v-model="workloadForm.sameAsLoggedInUser"
                      color="orange"
                      @change="onSameAsLoggedInUserChecked">
                      <template v-slot:label>
                        Check this box if same as logged in userss
                      </template>
                    </v-checkbox>
                    <v-progress-linear
                      v-slot:progress
                      v-if="workloadForm.loadingContact"
                      color="orange"
                      indeterminate/>
                    <v-layout
                      row
                      wrap>
                      <v-flex md6>
                        <v-text-field
                          :disabled="type==='view'"
                          v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
                          :clearable="!workloadForm.sameAsLoggedInUser"
                          v-model.lazy="workloadForm.contact.Contact_First_Name"
                          :error-messages="errors.collect('Contact_First_Name')"
                          :readonly="!workloadForm.sameAsLoggedInUser"
                          placeholder="First Name"
                          solo
                          data-vv-name="Contact_First_Name"
                          data-vv-validate-on="blur"
                          required
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          :disabled="type==='view'"
                          v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
                          :clearable="!workloadForm.sameAsLoggedInUser"
                          v-model.lazy="workloadForm.contact.Contact_Last_Name"
                          :error-messages="errors.collect('Contact_Last_Name')"
                          :readonly="!workloadForm.sameAsLoggedInUser"
                          class="last-name"
                          placeholder="Last Name"
                          solo
                          data-vv-name="Contact_Last_Name"
                          data-vv-validate-on="blur"
                          required
                        />
                      </v-flex>

                    </v-layout>
                    <v-layout
                      row
                      wrap>
                      <v-flex md6>
                        <v-text-field
                          :disabled="type==='view'"
                          v-validate="'required|email'"
                          :clearable="!workloadForm.sameAsLoggedInUser"
                          v-model.lazy="workloadForm.contact.Contact_Email"
                          :error-messages="errors.collect('Contact_Email')"
                          :readonly="workloadForm.sameAsLoggedInUser"
                          class="email"
                          placeholder="Contact email"
                          solo
                          data-vv-name="Contact_Email"
                          data-vv-validate-on="blur"
                          required
                          @change="onContactEmailChange"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          :disabled="type==='view'"
                          :clearable="!workloadForm.sameAsLoggedInUser"
                          v-model.lazy="workloadForm.contact.Contact_Phone"
                          :readonly="workloadForm.sameAsLoggedInUser"
                          class="phone"
                          placeholder="Contact phone"
                          solo
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout
                  v-if="type==='new'"
                  column
                  wrap
                  align-center
                  justify-center>
                  <v-flex md12 class="mt-2">
                    <p>Download the Opportunity Registration guide, available in the left column Galaxy menu, to understand the timeline graph on the steps towards AWS acceptance and notifications after you submit in Galaxy.  See the guide for how to view any DXC registration request and registration status. </p>
                    <hr />
                    <p class="mt-2">Again, if the client owned AWS account will be transferred to a DXC Master Payer, then after you click "submit", please email the DXC team at AWS Account <a href="mailto:Onboarding@cloud.dxc.com">Onboarding@cloud.dxc.com</a> for further assistance on pricing and account transfer to DCX process (CTA).</p>
                    <hr />
                    <p class="mt-2"> For any additional support, please contact the Galaxy team at <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a></p>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12>
                    <v-btn v-if="workloadForm.fields.Q7 === 'Y'" color="success" @click="goBackToStep(1)">GO BACK</v-btn>
                    <v-btn v-else color="success" @click="goBackToStep(2)">GO BACK</v-btn>
                    <v-btn
                      :loading="workloadForm.submitting"
                      :disabled="!formComplete || workloadForm.enteringNew || workloadForm.savingForLater || errors.items.length ? true : false"
                      class="opp-btn"
                      color="warning"
                      @click="onWorkloadSubmit('Submitted by User')">Submit</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-else-if="type==='edit'"
                  column
                  wrap
                  align-center
                  justify-center>
                  <v-flex v-if="type === 'new'" md12 >
                    <p>For standard Opportunity Registrations , download the Opportunity Registration guide which shows the overall submission and approval process and what you can expect after you click “submit”.</p>
                    <hr>
                    <p>If client’s workload is being transferred to DXC Master Payer, the AWS registration process is not applicable. Enter your contact info and click submit for DXC records.  Please connect with your AWS PDM for pricing. To apply for the Account Transfer process send an email request to <a href="mailto:AWS-Account-Onboarding@cloud.dxc.com">AWS-Account-Onboarding@cloud.dxc.com</a> </p>
                    <hr>
                    <p>Please contact for registration status or questions: <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a></p>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="type === 'new'">
                    <v-btn
                      :loading="workloadForm.savingForLater"
                      :disabled="!formComplete || workloadForm.submitting || errors.items.length ? true : false"
                      class="opp-btn"
                      color="warning"
                      @click="onUpdateWorkload('Ready for submission')">Update</v-btn>
                    <v-btn
                      :loading="workloadForm.submitting"
                      :disabled="!formComplete || workloadForm.savingForLater || errors.items.length || workloadForm.fields.Workload_Status == 'Submitted by User'"
                      class="opp-btn"
                      color="warning"
                      @click="onUpdateWorkload('Submitted by User')">Submit</v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content
                step="4"
                class="qa-form"
              >
                <div id="update-discount" class="py-3 px-3">
                  <div class="pricing-tier-overview-container">
                      <div class="my-2 px-2 py-1 black">
                          <label class="font-weight-bold white--text">Pricing Tiers Overview [<a href="#" @click="downloadGuide" >Download Oppreg Guide for more details</a>] </label>
                      </div>
                      <div class="px-2 py-2">
                          <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                          <ul>
                              <li><a href="#" @click="downloadGuide" ><u>Download Oppreg Guide</u></a> for discount details. Note the public sector SPP qualifications in the OppReg guide.</li>
                              <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                              <li>Private Pricing Agreement (PPA) – 21% discount for qualified workloads.</li>
                              <li>View the OppReg guide download for pricing tier details. </li>
                          </ul>
                      </div>
                  </div>
                  <v-layout
                      row
                      wrap
                  >
                      <v-flex md12>
                      <div class="my-2 px-2 py-1 black">
                          <label class="font-weight-bold white--text">Pricing Qualification Version 2.0</label>
                      </div>
                      <div class="my-2">
                          <label class="font-weight-bold red--text">Select the ONE statement that applies to the AWS workload *</label>
                      </div>

                      <v-layout
                          column
                          >
                          <v-radio-group
                              readonly
                              light
                              class="pricing-tier-qualification px-3"
                              v-model="workloadForm.fields.Pricing_Tier_Qualification_2">
                              <v-radio
                                  class="my-2 pricing-tier-radio"
                                  value="1"
                                  color="orange"
                              >
                                  <span slot="label" class="ml-2 black--text">1. The solution is based primarily on DXC IP whereby the customer will not have access to the associated AWS services, infrastructure or operating systems managed by DXC.</span>
                              </v-radio>
                              <div v-if="workloadForm.fields.Pricing_Tier_Qualification_2 === '1'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                                  <label class="font-weight-bold black--text title">1. Based on your selection of #1, this workload qualifies for the PPA discount</label>
                              </div>
                              <v-radio
                                  class="my-2 pricing-tier-radio"
                                  value="2"
                                  color="orange"
                              >
                                  <span slot="label" class="ml-2 black--text">2. The customer requires direct access to the AWS Console, workloads, services, or logs. </span>
                              </v-radio>
                              <div v-if="workloadForm.fields.Pricing_Tier_Qualification_2 === '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                                  <label class="font-weight-bold black--text title">2. Based on your selection of #2, this workload qualifies for the SPP discount</label>
                              </div>
                          </v-radio-group>
                      </v-layout>
                      <div class="my-2 px-2 py-1 black">
                          <label class="font-weight-bold white--text">Attestation</label>
                      </div>
                      <v-layout row style="gap: 1rem">
                          <v-flex md6>
                              <v-text-field
                                  v-model="workloadForm.fields.Attested_By_Date_2"
                                  label="Attested Date"
                                  readonly
                              />
                          </v-flex>
                          <v-flex md6>
                              <v-text-field
                                  v-model="workloadForm.fields.Attested_By_Email_2"
                                  label="Email *"
                                  readonly
                              />
                          </v-flex>
                      </v-layout>
                      <v-layout style="gap: 1rem">
                          <v-flex md6>
                          <v-text-field
                              v-model.lazy="workloadForm.fields.Attested_By_Title_2"
                              label="Job Title *"
                              readonly
                          />
                          </v-flex>
                          <v-flex md6>
                          <v-text-field
                              v-model.lazy="workloadForm.fields.Attested_By_Manager_2"
                              label="Manager *"
                              readonly
                          />
                          </v-flex>
                      </v-layout>
                      <div>
                          <p>Attestation and the response content is required for contractual compliancy. This attestation is subject to audit. Inaccurate responses could change the pricing tier. If you are unsure of responses throughout this application for registration, please defer to your manager to assist. </p>
                      </div>
                      </v-flex>
                  </v-layout>
              </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { generateRegistrationID } from '@/utils/helper'


export default {
  props: {
    sfdcId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    view: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      awsServices: [
        { text: 'Alexa Web Information Service', value: 'Alexa Web Information Service', selected: false },
        { text: 'Amazon Registrar', value: 'Amazon Registrar', selected: false },
        { text: 'AWS Marketplace', value: 'AWS Marketplace', selected: false },
        { text: 'Beta Services (as described in the Service Terms)', value: 'Beta Services (as described in the Service Terms)', selected: false },
        { text: 'Amazon S3 Glacier Deep Archive', value: 'Amazon S3 Glacier Deep Archive', selected: false },
        { text: 'Deep Archive', value: 'Deep Archive', selected: false },
        { text: 'AWS IQ', value: 'AWS IQ', selected: false },
        { text: 'Not Applicable', value: 'Not Applicable', selected: false }
      ],
      attestedDateMenu: false,
      viewOldPricingQA: false,
      solutionBusinessSegments: [
        'DXC Insurance Software Business (ISB)',
        'DXC Consulting & Engineering Services (CES)',
        'DXC Global Infrastructure Services (GIS)',
      ],
    }
  },
  computed: {
    ...mapState('user/requestOppreg', ['workloadForm','workloadStep', 'oppType', 'manualRegistration']),
    currentDate () {
      return window.moment().format('YYYY-MM-DD')
    },
    // registrationID () {
    //   return this.workloadForm.fields.Registration_Id = generateRegistrationID(this.sfdcId, this.workloadForm.fields.Workload_Title)
    // },
    formStep: {
      get: function () {
        return this.workloadStep
      },
      set: function (step) {
        this.$store.commit('user/requestOppreg/setWorkloadStep', step)
      }
    },
    computedAwsServices: {
      get: function () {
        let workloadAwsServices = JSON.parse(this.workloadForm.fields.WL_Q7A)
        let awsServices = this.awsServices.map((service, index) => {
          let serviceFound = workloadAwsServices.some(value => value === service.value)
          if (serviceFound) {
            return { ...service, selected: true }
          } else {
            return { ...service, selected: false }
          }
        })
        return awsServices
      }
    },
    formComplete () {
      if(this.workloadForm.oppType === ''){
              return this.workloadForm.fields.Workload_Title &&
              this.workloadForm.fields.Workload_type &&
              this.workloadForm.contact.Contact_First_Name &&
              this.workloadForm.contact.Contact_Last_Name &&
              this.workloadForm.contact.Contact_Email &&
              !this.workloadForm.loadingContact
      } else {
          return this.workloadForm.fields.Workload_Title &&
              this.workloadForm.fields.Workload_type &&
              this.workloadForm.contact.Contact_First_Name &&
              this.workloadForm.contact.Contact_Last_Name &&
              this.workloadForm.contact.Contact_Email &&
              !this.workloadForm.loadingContact
      }

    },
    workloadType () {
      let newWorkloadTypeCalculation
      if (this.workloadForm.fields.Q8 === 'Y') {
        newWorkloadTypeCalculation = 'SPP'
      } else if (this.workloadForm.fields.Q9 === 'Y') {
        newWorkloadTypeCalculation = 'PPA'
      } else if (this.workloadForm.fields.Q10 === 'Y'){
        newWorkloadTypeCalculation = 'PPA'
      } else if (this.workloadForm.fields.Q10 === 'N'){
        newWorkloadTypeCalculation = 'SPP'
      }

      this.setWorkloadType(newWorkloadTypeCalculation)
      return newWorkloadTypeCalculation
    },
    stepOneValidation () {
      if (this.workloadForm.fields.Campaign_Name.includes('Glacier') && !this.workloadForm.fields.Scope_of_Work) {
        return true
      } 
      
      if (!this.workloadForm.fields.Workload_Title || !this.workloadForm.fields.Solution_Business_Segment || !this.workloadForm.fields.Q1 || !this.workloadForm.fields.Q2 || !this.workloadForm.fields.Q3 || !this.workloadForm.fields.Q4 || !this.workloadForm.fields.Q5 || !this.workloadForm.fields.Q6 || !this.workloadForm.fields.Q7) {
        return true
      } 
      
      if (!(this.workloadForm.registrationIdValidation.error || this.workloadForm.registrationIdValidation.loading)) {
        return false
      }
      // all input fiels are properly filled
      return false
    },
    stepTwoValidation () {
      if (this.errors.items.length > 0) {
        return true
      }

      if (!this.workloadForm.fields.Attested_By_Date || !this.workloadForm.fields.Attested_By_Email || !this.workloadForm.fields.Attested_By_Title || !this.workloadForm.fields.Attested_By_Manager) {
        return true
      }

      if (!this.workloadForm.fields.Discount_Tier_On_AWS || (this.workloadForm.fields.Discount_Tier_On_AWS === 'False' && !this.workloadForm.fields.Discount_Tier_On_AWS_2) || (this.workloadForm.fields.Discount_Tier_On_AWS_2 === 'False' && this.workloadForm.fields.Pricing_Tier_Qualification == null) ) {
        return true
      }
    },
    attestedDate: {
      get () {
        return window.moment(this.workloadForm.fields.Attested_By_Date).isValid()
          ? this.workloadForm.fields.Attested_By_Date
          : null
      },
      set (date) {
        this.workloadForm.fields.Attested_By_Date = date
      }
    },
  },
  mounted () {
    this.setWorkloadStep(1)
    console.log(this.workloadForm)

    if (this.workloadForm.fields.Contact_Id) {
      this.$store.dispatch('user/requestOppreg/loadRelatedContact', this.workloadForm.fields.Contact_Id)
    }
    this.$validator.localize(this.dictionary)
    window.onhashchange = () => {
      if (this.$router.history.current.hash === '#showMoreInfo') {
        this.moreAWSWarningDialog = true
        this.$store.commit('setSnackbar', { show: false })
      }
    }
  },
  beforeDestroy () {
    // this.$store.commit('user/requestOppreg/clearWorkloadForm')
    this.$store.commit('user/requestOppreg/resetForm')
    this.$store.commit('clearLogRecord')
    this.setWorkloadStep(1)
  },
  methods: {
    ...mapActions({
      submitWorkload: 'user/requestOppreg/submitWorkload',
      updateWorkload: 'user/requestOppreg/updateWorkload',
      validateRegistrationId: 'user/requestOppreg/validateRegistrationId'
    }),
    ...mapMutations({
      updateSelectedAwsServices: 'user/requestOppreg/setSelectedAwsServices',
      setWorkloadStatus: 'user/requestOppreg/setWorkloadStatus',
      setWorkloadType: 'user/requestOppreg/setWorkloadType',
      updateContact: 'user/requestOppreg/setWorkloadContact',
      clearContact: 'user/requestOppreg/clearWorkloadContact',
      setWorkloadStep: 'user/requestOppreg/setWorkloadStep',
      clearDiscountAnswers: 'user/requestOppreg/clearDiscountAnswers'
    }),
    ...mapGetters({
      getSelectedAwsServices: 'user/requestOppreg/getSelectedAwsServices'
    }),
    updatedSelectedAwsServices () {
      let workloadAwsServices = this.computedAwsServices.filter(service => service.selected).map(service => service.value)
      this.$store.commit('user/requestOppreg/setSelectedAwsServices', workloadAwsServices)
    },
    onWorkloadStepContinue (step) {
      this.setWorkloadStep(step)
    },
    goBackToStep(step) {
      if(step !== undefined){ 
        this.setWorkloadStep(step)
      } else {
      this.$emit('previous')
      }
    },
    onProjectDescOptionOneClicked () {
      this.$store.commit('showDialog', {
        show: true,
        type: 'confirmation',
        persistent: true,
        title: '',
        description: `<span style='color:#f55a4e; font-weight: bold;'>STOP!</span> This registration is for net-new-to-AWS workloads only. 
          If your opportunity contains additional types of workloads not already running on AWS, 
          continue with this registration by choosing another registration option. 
          To move your client's existing AWS workloads (i.e. shareshift) to a DXC account, 
          please click <a href='#showMoreInfo' style='font-weight: bold; text-decoration: underline'>HERE</a> for more information
          <br /><br /><span style='font-weight: bold'>Do you want to continue?</span>`,
        yesHandler: () => {
          this.existingWorkLoadonAWStoDXC = false
          this.$store.commit('resetDialog', null, { root: true })
        },
        noHandler: () => {
          this.gotoMain()
          this.$store.commit('resetDialog', null, { root: true })
        }
      }, { root: true })
    },
    onWorkloadSubmit (status) {
      this.setWorkloadStatus(status)
      this.submitWorkload(this.workloadForm)
    },
    onUpdateWorkload (status) {
      this.setWorkloadStatus(status)
      this.updateWorkload(this.workloadForm)
    },
    toggleIsGlacier (val) {
      this.workloadForm.fields.Campaign_Name = val == 'Y' ? 'Glacier' : ''
    },
    // onWorkloadTitleChange () {
    //   // console.log('Your current OPPTYPE: ', this.workloadForm.oppType )
    //   // console.log(this.sfdcId)
    //   // console.log(this.workloadForm.fields.Workload_Title)
    //   if(this.workloadForm.oppType === ''){
    //     this.validateRegistrationId(generateRegistrationID(this.sfdcId, this.workloadForm.fields.Workload_Title))
    //   }
    //   // this.validateRegistrationId(this.workloadForm.fields.Registration_Id)
    // },
    onSameAsLoggedInUserChecked (flag) {
      if (flag) {
        // Issue: vee validate error bag items is not being cleared if inputs did not emit change event. Issue is specific for contact info fields if error already occurs then we fill in state without triggering event.
        this.clearErrorBagMessages(['Contact_First_Name', 'Contact_Last_Name', 'Contact_Email'])
        let contactUser = this.$store.state.currentUser
        this.updateContact({
          Contact_Id: contactUser.contact_id,
          Contact_Last_Name: contactUser.family_name,
          Contact_First_Name: contactUser.given_name,
          Contact_Email: contactUser.email,
          Contact_Phone: contactUser.phone
        })
      } else {
        this.clearContact()
      }
    },
    clearErrorBagMessages (fields) {
      fields.forEach(field => this.errors.remove(field))
    },
    onContactEmailChange () {
      this.workloadForm.fields.Contact_Id = ''
    },
    determineWorkloadType () {
      let workloadType
      if (this.workloadForm.fields.Q7 === 'Y') {
        workloadType = 'Transfer'
        this.setWorkloadType(workloadType)
        this.clearDiscountAnswers()
      } else if (this.workloadForm.fields.Q7 === 'N') {
        this.setWorkloadType('N/A')
      }
    },
    downloadGuide () {
      window.open(window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf', '_blank').focus();
    },

    displayPublicSectorMessage () {
      if (this.workloadForm.fields.Q6 === 'Y') {
        this.$store.commit('showDialog', {
          show: true,
          description:  `If response is yes -that  DXC Advisory services will encompass a Cloud Service Provider selection or procurement
          - then an SPP pricing discount determination on the next page will only qualify for 7%, instead of 12%.
           <a href='${window.location.origin}/DXC+AWS+Opportunity+Registration+Guide.pdf' target="_blank"><u>Download Oppreg Guide</u></a> for more details.`,
        }, { root: true })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.nodisplay{ display: none }
.header {
    background: #000;
    color: #fff;
    padding: 0 15px;
    margin: 10px 0;
    .container span{
      font-style: 600;
      text-decoration: underline
    }
}
#oppreg-qa {

    .disabled-section {
        background: #f5f5f5;
        width: 100%;
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 99;
        height: 100%;
        opacity: 0.4
    }

    .disable-events {
        pointer-events: none
    }
  
    .pricing-tier-overview-container > p {
      border-bottom: 1px solid #000;
      font-size: 16px !important;
      color: #000;
    }

    header {
      background: #000;
      color: #fff;
      margin: 10px 10px;
      .container {
        padding: 0 25px;
      }
      .container span{
        font-weight: 600;
        text-decoration: underline;
      }
    }
    .workload-type {
      padding-top: 33px;
      padding-left: 10px;
    }
    .qa-form {
      .v-btn-toggle{ margin:10px 0}
      .v-btn-toggle .v-btn{
        padding: 15px 38px;
        opacity: 1;
      }
      
      .btn--qa{
        font-weight: bold !important;
      }

      .v-select--width{
        width: 100%;
      }

      span{
        &.workload-desc{
          font-weight:600
        }
      }
      div {
        &.qa-desc{
          font-style: italic;
          font-size: 14px;
        }
      }
      .input-symbol-dollar {
          position: relative;
          display: block;
        }
        .input-symbol-dollar:after {
            color: #37424a !important;
            content: "$";
            font-size: 16px !important;
            font-weight: 400;
            position: absolute;
            display: block;
            height: 100%;
            top: 0;
            left: 10px;
            line-height: 42px;
        }
        .padding-left-15.v-text-field input{
          padding-left:15px;
          background: yellow;
        }
        // .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){
        //   background-color: grey;
        // }
        .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
          background-color: grey;
        }
         .opp-btn {
          width: 200px;
        }
    }
}
.workload-info{
  p{
    margin: 25px 0;
    font-size: 16px !important
  }
}

.v-input.aws-option {
  margin-top: 0;
  height: 35px;
}

.v-input.service-region {
  margin-top: 0;
  height: 35px;
}

.sow-field {
  margin-bottom: 40px;
}
</style>
